export default __webpack_public_path__ + "static/ezpawn-ad-67f8000a86a255a2ffbd086a688fe29d.jpg";